import Ajax from '@/utils/request'

const ajax = new Ajax()

// 获取token价格
export const getTokenPrice = {
  fetcher: (params: string) => ajax.get(`/token/${params}`),
  key: '/token',
}
